import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userServices from "./userServices";

const initialState = {
  // getUser data
  userData: "",
  userisError: false,
  userisSuccess: false,
  userisLoading: false,
  usererrorMsg: "",

  // getUser data
  recentUser: "",
  status: "",
  error: false,

  // view user
  viewUserData: "",
  viewUserisError: false,
  viewUserisSuccess: false,
  viewUserisLoading: false,
  viewUsererrorMsg: "",

  // delete all
  deleteAllUserState: "",
  deleteAllUserSuccess: false,
  deleteAllUserError: false,
  deleteAllUserLoading: false,
  deleteAllUserErrMsg: "",
  // delete user
  deleteUserState: "",
  deleteUserSuccess: false,
  deleteUserError: false,
  deleteUserLoading: false,
  deleteUserErrMsg: "",

  // edit user
  editUserState: "",
  editUserSuccess: false,
  editUserError: false,
  editUserLoading: false,
  editUserErrMsg: "",
  // dashboard data

  dashboardUserState: "",
  dashboardUserSuccess: false,
  dashboardUserError: false,
  dashboardUserLoading: false,
  dashboardUserErrMsg: "",

  // profile / general
  profileState: "",
  profileStateSuccess: false,
  profileStateError: false,
  profileStateLoading: false,
  profileStateErrorMsg: "",

  // updatePageName
  updatePageNameState: "",
  updatePageNameSuccess: false,
  updatePageNameError: false,
  updatePageNameLoading: false,
  updatePageNameErrorMsg: "",


  // updatePassword
  updatePasswordState: "",
  updatePasswordSuccess: false,
  updatePasswordError: false,
  updatePasswordLoading: false,
  updatePasswordErrorMsg: "",

  // userLogsList
  userLogsLists: "",
  userLogListSuccess: false,
  userLogListError: false,
  userLogListLoading: false,
  userLogErrMsg: "",
};

// getUser getUser
export const getUser = createAsyncThunk(
  "getUser/getUser",

  async (data, thunkAPI) => {
    try {
      return await userServices.getUser(data);
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const viewUser = createAsyncThunk(
  "user/viewUser",

  async (data, thunkAPI) => {
    try {
      return await userServices.viewUser(data);
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// delete all users
export const deleteAllUser = createAsyncThunk(
  "deleteCodes/deleteAllUser",
  async (data, thunkAPI) => {
    try {
      return await userServices.deleteAllUser(data);
    } catch (error) {
      const codeerrorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.codeerrorMsg) ||
        error.codeerrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(codeerrorMsg);
    }
  }
);
//  delete user
export const deleteUser = createAsyncThunk(
  "deleteCodes/deleteUser",
  async (data, thunkAPI) => {
    try {
      return await userServices.deleteUser(data);
    } catch (error) {
      const codeerrorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.codeerrorMsg) ||
        error.codeerrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(codeerrorMsg);
    }
  }
);

// edit user
export const editUser = createAsyncThunk(
  "edit/editUser",
  async (data, thunkAPI) => {
    try {
      return await userServices.editUser(data);
    } catch (error) {
      const codeerrorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.codeerrorMsg) ||
        error.codeerrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(codeerrorMsg);
    }
  }
);

// dashboard user
export const showingDashboardUser = createAsyncThunk(
  "show/showingDashboardUser",
  async (data, thunkAPI) => {
    try {
      return await userServices.showingDashboardUser(data);
    } catch (error) {
      const codeerrorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.codeerrorMsg) ||
        error.codeerrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(codeerrorMsg);
    }
  }
);

export const getLastFiveUser = createAsyncThunk(
  "getUser/getLastFiveUser",
  async (data) => {
    try {
      return await userServices.getLastFiveUser(data);
    } catch (error) {
      console.error(error.message);
    }
  }
);

export const updataProfileState = createAsyncThunk(
  "userProfile/updataProfileState",
  async (data) => {
    try {
      return await userServices.updataProfileState(data);
    } catch (error) {
      console.error(error.message);
    }
  }
);

//  user log list
export const userLogList = createAsyncThunk(
  "userLog/userLogList",
  async (data, thunkAPI) => {
    try {
      return await userServices.userLogList(data);
    } catch (error) {
      const codeerrorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.codeerrorMsg) ||
        error.codeerrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(codeerrorMsg);
    }
  }
);

export const updatePageName = createAsyncThunk(
  "updatePageName",

  async (headingkData, thunkAPI) => {
    try {
      const response = await userServices.savePageName(headingkData);
      return response;
    } catch (error) {
      const isChangeBLockErrorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.isChangeBLockErrorMsg) ||
        error.isChangeBLockErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(isChangeBLockErrorMsg);
    }
  }
);

export const updateAccountDetail = createAsyncThunk(
  "updateAccountDetail",

  async (data, thunkAPI) => {
    try {
      const response = await userServices.saveAccountDetail(data);
      return response;
    } catch (error) {
      const profileStateErrorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.profileStateErrorMsg) ||
        error.profileStateErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(profileStateErrorMsg);
    }
  }
);

export const updatePassword = createAsyncThunk(
  "updatePassword",

  async (data, thunkAPI) => {
    try {
      const response = await userServices.savePassword(data);
      return response;
    } catch (error) {
      const isChangeBLockErrorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.isChangeBLockErrorMsg) ||
        error.isChangeBLockErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(isChangeBLockErrorMsg);
    }
  }
);

export const userSlice = createSlice({
  name: "getUser",
  initialState,
  reducers: {
    resetUser: (state) => {
      state.userisLoading = false;
      state.userisSuccess = false;
      state.userisError = false;
      state.usererrorMsg = "";

      // view user
      state.viewUserisLoading = false;
      state.viewUserisSuccess = false;
      state.viewUserisError = false;
      state.viewUsererrorMsg = "";

      // delete all
      state.deleteAllUserLoading = false;
      state.deleteAllUserSuccess = false;
      state.deleteAllUserError = false;
      state.deleteAllUserErrMsg = "";

      //  delete user
      state.deleteUserLoading = false;
      state.deleteUserSuccess = false;
      state.deleteUserError = false;
      state.deleteUserErrMsg = "";

      // update account details
      state.profileStateLoading = false;
      state.profileStateSuccess = false;
      state.profileStateError = false;
      state.profileStateErrorMsg = "";

      // updatePageName
      state.updatePageNameSuccess = false;
      state.updatePageNameError = false;
      state.updatePageNameLoading = false;
      state.updatePageNameErrorMsg = "";

      // updatePassword
      state.updatePasswordSuccess = false;
      state.updatePasswordError = false;
      state.updatePasswordLoading = false;
      state.updatePasswordErrorMsg = "";

      // edit user
      state.editUserLoading = false;
      state.editUserSuccess = false;
      state.editUserError = false;
      state.editUserErrMsg = "";
      // edit user
      state.userLogListSuccess = false;
      state.userLogListError = false;
      state.userLogListLoading = false;
      state.userLogErrMsg = "";

      // dashboard user
      state.dashboardUserLoading = false;
      state.dashboardUserSuccess = false;
      state.dashboardUserError = false;
      state.dashboardUserErrMsg = "";
      state.status = "";
      state.error = false;
    },
    filterUsers: (state, action) => {
      state.userData.response = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.userisLoading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.userisLoading = false;
        state.userisSuccess = true;
        state.userData = action.payload;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.userisLoading = false;
        state.userisError = true;
        state.usererrorMsg = action.payload;
      })
      .addCase(getLastFiveUser.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getLastFiveUser.fulfilled, (state, action) => {
        state.status = "fullfilled";
        state.recentUser = action.payload;
      })
      .addCase(getLastFiveUser.rejected, (state) => {
        state.status = "rejected";
        state.error = true;
      })

      // view user
      .addCase(viewUser.pending, (state) => {
        state.viewUserisLoading = true;
      })
      .addCase(viewUser.fulfilled, (state, action) => {
        state.viewUserisLoading = false;
        state.viewUserisSuccess = true;
        state.viewUserData = action.payload;
      })
      .addCase(viewUser.rejected, (state, action) => {
        state.viewUserisLoading = false;
        state.viewUserisError = true;
        state.viewUsererrorMsg = action.payload;
      })

      // delete All
      .addCase(deleteAllUser.pending, (state) => {
        state.deleteAllUserLoading = true;
      })
      .addCase(deleteAllUser.fulfilled, (state, action) => {
        state.deleteAllUserLoading = false;
        state.deleteAllUserSuccess = true;
        state.deleteAllUserState = action.payload;
      })
      .addCase(deleteAllUser.rejected, (state, action) => {
        state.deleteAllUserLoading = false;
        state.deleteAllUserError = true;
        state.deleteAllUserErrMsg = action.payload;
      })

      // delete user
      .addCase(deleteUser.pending, (state) => {
        state.deleteUserLoading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.deleteUserLoading = false;
        state.deleteUserSuccess = true;
        state.deleteUserState = action.payload;
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.deleteUserLoading = false;
        state.deleteUserError = true;
        state.deleteUserErrMsg = action.payload;
      })

      // edit  user
      .addCase(editUser.pending, (state) => {
        state.editUserLoading = true;
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.editUserLoading = false;
        state.editUserSuccess = true;
        state.editUserState = action.payload;
      })
      .addCase(editUser.rejected, (state, action) => {
        state.editUserLoading = false;
        state.editUserError = true;
        state.editUserErrMsg = action.payload;
      })

      // show data dashboard  user
      .addCase(showingDashboardUser.pending, (state) => {
        state.dashboardUserLoading = true;
      })
      .addCase(showingDashboardUser.fulfilled, (state, action) => {
        state.dashboardUserLoading = false;
        state.dashboardUserSuccess = true;
        state.dashboardUserState = action.payload;
      })
      .addCase(showingDashboardUser.rejected, (state, action) => {
        state.dashboardUserLoading = false;
        state.dashboardUserError = true;
        state.dashboardUserErrMsg = action.payload;
      })

      // update profile data
      .addCase(updateAccountDetail.pending, (state) => {
        state.profileStateLoading = true;
      })
      .addCase(updateAccountDetail.fulfilled, (state, action) => {
        state.profileStateLoading = false;
        state.profileStateSuccess = true;
        state.profileState = action.payload;
      })
      .addCase(updateAccountDetail.rejected, (state, action) => {
        state.profileStateLoading = false;
        state.profileStateError = true;
        state.profileStateErrorMsg = action.payload;
      })

      // update pageName
      .addCase(updatePageName.pending, (state) => {
        state.updatePageNameLoading = true;
      })
      .addCase(updatePageName.fulfilled, (state, action) => {
        state.updatePageNameLoading = false;
        state.updatePageNameSuccess = true;
        state.updatePageNameState = action.payload;
      })
      .addCase(updatePageName.rejected, (state, action) => {
        state.updatePageNameLoading = false;
        state.updatePageNameError = true;
        state.updatePageNameErrorMsg = action.payload;
      })
      // update passwords
      .addCase(updatePassword.pending, (state) => {
        state.updatePasswordLoading = true;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.updatePasswordLoading = false;
        state.updatePasswordSuccess = true;
        state.updatePasswordState = action.payload;
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.updatePasswordLoading = false;
        state.updatePasswordError = true;
        state.updatePasswordErrorMsg = action.payload;
      })
      // profile / general

      .addCase(updataProfileState.pending, (state) => {
        state.profileStateLoading = true;
      })
      .addCase(updataProfileState.fulfilled, (state, action) => {
        state.profileStateLoading = false;
        state.profileStateSuccess = true;
        state.profileState = action.payload;
      })
      .addCase(updataProfileState.rejected, (state, action) => {
        state.profileStateLoading = false;
        state.profileStateError = true;
        state.profileStateErrorMsg = action.payload;
      })

      //  user log list #

      .addCase(userLogList.pending, (state) => {
        state.userLogListLoading = true;
      })
      .addCase(userLogList.fulfilled, (state, action) => {
        state.userLogListLoading = false;
        state.userLogListSuccess = true;
        state.userLogsLists = action.payload;
      })
      .addCase(userLogList.rejected, (state, action) => {
        state.userLogListLoading = false;
        state.userLogListError = true;
        state.userLogErrMsg = action.payload;
      });
  },
});

export const { resetUser, filterUsers } = userSlice.actions;
export default userSlice.reducer;
